import { useQuery } from '@tanstack/react-query';
import { houseApi } from '../api/houseApi';
import type { HouseFiltersType } from '../types';

export const useHouses = (filters: HouseFiltersType) => {
  return useQuery({
    queryKey: ['houses', filters],
    queryFn: () => houseApi.getHousesWithFilters(filters),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: (failureCount, error: any) => {
      // Don't retry on 4xx errors except 408, 429
      if (error?.response?.status >= 400 && error?.response?.status < 500) {
        if (![408, 429].includes(error.response.status)) {
          return false;
        }
      }
      return failureCount < 3;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

export const useHousesList = () => {
  return useQuery({
    queryKey: ['houses-list'],
    queryFn: () => houseApi.getHousesList(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: (failureCount, error: any) => {
      // Don't retry on 4xx errors except 408, 429
      if (error?.response?.status >= 400 && error?.response?.status < 500) {
        if (![408, 429].includes(error.response.status)) {
          return false;
        }
      }
      return failureCount < 3;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    // onError removed - use error handling in components instead
  });
};

export const useHouse = (id: string) => {
  return useQuery({
    queryKey: ['houses', id],
    queryFn: () => houseApi.getHouseById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: (failureCount, error: any) => {
      // Don't retry on 4xx errors except 408, 429
      if (error?.response?.status >= 400 && error?.response?.status < 500) {
        if (![408, 429].includes(error.response.status)) {
          return false;
        }
      }
      return failureCount < 3;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

export const useHouseOverview = (days: number = 30) => {
  return useQuery({
    queryKey: ['house-overview', days],
    queryFn: () => houseApi.getHouseOverview(days),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: (failureCount, error: any) => {
      // Don't retry on 4xx errors except 408, 429
      if (error?.response?.status >= 400 && error?.response?.status < 500) {
        if (![408, 429].includes(error.response.status)) {
          return false;
        }
      }
      return failureCount < 3;
    },
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};
